import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';

export default class ToastConfig extends Component{
    render(){
        return (
            <div>
                <ToastContainer
                    position="top-right"
                    type="default"
                    autoClose={4000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                />
            </div>
        )
    }
}